import api from '../../api/'
import * as types from '../mutation-types'

export const getAllExercises = ({ dispatch, state }) => {
  if (state.exercises.all.length === 0) {
    dispatch(types.ASYNC_REQUEST)

    api
    .getExercises()
    .then(response => {
      dispatch(types.RECEIVE_EXERCISES, response.data)
      dispatch(types.ASYNC_SUCCESS)
    })
  }
}

export const getExercise = ({ dispatch, state }, id) => {
  return new Promise(resolve => {
    if (state.exercises.all.length === 0) {
      dispatch(types.ASYNC_REQUEST)

      api
      .getExercises()
      .then(response => {
        dispatch(types.RECEIVE_EXERCISES, response.data)
        dispatch(types.ASYNC_SUCCESS)
        dispatch(types.SET_ACTIVE_EXERCISE, id)
        resolve()
      })
    } else {
      dispatch(types.SET_ACTIVE_EXERCISE, id)
      resolve()
    }
  })
}

export const updateIndex = ({ dispatch, state }, oldIndex, newIndex) => {
  dispatch(types.UPDATE_EXERCISE_INDEX, oldIndex, newIndex)
}



// WEBPACK FOOTER //
// ./src/vuex/exercises/actions.js